import { InjectionToken } from '@angular/core';

export interface ServiceWorkerRegistrationHandler {
    handleRegistration(registration: ServiceWorkerRegistration): void | Promise<void>;
}

/**
 * This must be provided to an `@NgModule()` using provider option `multi: true`
 * This is an optional set of callbacks that an app can provide to interact with the ServiceWorker registration after
 * `window.navigator.serviceWorker.register(...)` is called
 */
export const SERVICE_WORKER_REGISTRATION_HANDLERS = new InjectionToken<Array<ServiceWorkerRegistrationHandler>>('SERVICE_WORKER_REGISTRATION_HANDLERS');
